import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import Topbar from "../../components/Topbar/Topbar";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { checkPermission } from "../redux/api/PermissionManager";

const CalenderAvailability = () => {
  const [list, setList] = useState([]);
   const [type, setType] = useState(true);
   const [id, setId] = useState();
   const [errors, setErrors] = useState(false);
   const [loading, setLoading] = useState(false);
   const [totalPages, settotalPages] = useState();

 
   const fetchCategories = async (page = 1) => {
     try {
       const url = URLS.CALENDAR_AVAILABILITY_LIST;
 
       const res = await get(url);
 
       setList(res?.data?.[0]?.name || []);
       setId(res?.data?.[0]?.id || []);
     
     } catch (err) {
       console.error(err);
     }
   };
 
   useEffect(() => {
     fetchCategories();
   }, []);
 
   
   const handleSubmit = async () => {
    setType(!type);
if(!type){
     if (!list) {
       toast.error("Enter No of Days");
       setType(false);
       return;
     } else {
       setLoading(true);
       setErrors(false);
       const formdata = new FormData();
       formdata.append("type", 51);
       formdata.append("name", list);
 
         try {
           const res = await post(`${URLS.CALENDAR_AVAILABILITY_EDIT}/${id}/edit/`, formdata);
           setLoading(false);
         } catch (err) {
           console.error(err);
          
           setLoading(false);
         } finally {
           setLoading(false);
         }
       }
     }
     }
 
   
 
   return (
     <div>
       <Topbar header={"Master"} subHead={"Calendar Availability"} />
         <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mt-5">Calendar Availability
         </h2>
    
       <div className="cal-box">
         <h2 className=" f2 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">No Of Days
         </h2>
         <p className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 err mt-3 ">Enter the number of days to block the rooms.</p>
       <div className="d-flex ac-jb mt-3">
        <input type="text" readOnly={type} className="input-box w-50 bg-white" value={list} onChange={(e)=>setList(e.target.value)} />
        <button onClick={handleSubmit} className={`${type?"deactive-btn":"active-btn"}`}>{type?"Edit":"Submit"}</button>
       </div>
       </div>
    
   
  
       {loading && <Loader />}
     </div>
   );
 };
 

export default CalenderAvailability